var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.adminAccess)?_c('div',[_vm._t("admin")],2):_c('div',[_vm._t("teacher")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }